"use client";

import { useTranslation } from "@/hooks/localization/useTranslations";
import {
  EventLocationType,
  IEventCustomData,
} from "@/api/AppApi/services/home/IEvent";
import { ISelling_Prices } from "@/api/AppApi/services/home/interfaces/IProduct";
import calculatPricesForSpecialPrices from "@/utils/functions/calculatPriceForSpecialPrices";
import ProductPrice from "@/app/components/common-builder/product/product-box/product-box-helpers/ProductPrice";
import SvgCalenderIcon from "@/app/components/common-builder/product/product-box/product-box-helpers/event/icons/SvgCalenderIcon";
import SvgLocationIcon from "@/app/components/common-builder/product/product-box/product-box-helpers/event/icons/SvgLocationIcon";
import SvgCheckCircleIcon from "@/app/components/common-builder/product/product-box/product-box-helpers/event/icons/SvgCheckCircleIcon";
import SvgMonyIcon from "@/app/components/common-builder/product/product-box/product-box-helpers/event/icons/SvgMonyIcon";
import SvgClockIcon from "@/app/components/common-builder/product/product-box/product-box-helpers/event/icons/SvgClockIcon";
import EventDetailItem from "./EventDetailItem";
import MapLink from "./MapLink";

interface EventDetailsProps extends IEventCustomData {
  price: number;
  price_without_discount: number;
  special_prices: ISelling_Prices[];
}

const EventDetails: React.FC<EventDetailsProps> = ({
  start_date,
  start_time,
  end_date,
  end_time,
  price: originalPrice,
  price_without_discount,
  available_seats,
  end_registration_date,
  end_registration_time,
  location,
  location_detail,
  location_type,
  special_prices,
}) => {
  const quantity = 0;
  const t = useTranslation();
  const { price, price_without_discount: priceWithoutDiscount } =
    calculatPricesForSpecialPrices({
      originalPrice,
      originalPriceWithoutDiscount: price_without_discount,
    })({ quantity, specialPrices: special_prices });

  const locationText =
    location_type === EventLocationType.physical ? location_detail! : "Online";

  return (
    <div className="event-details-container">
      <EventDetailItem
        icon={<SvgCalenderIcon />}
        title={t.start_date}
        content={start_date}
      />

      <EventDetailItem
        icon={<SvgClockIcon />}
        title={t.start_time}
        content={start_time}
      />

      <EventDetailItem
        icon={<SvgCalenderIcon />}
        title={t.end_date}
        content={end_date}
      />

      <EventDetailItem
        icon={<SvgClockIcon />}
        title={t.end_time}
        content={end_time}
      />

      <EventDetailItem
        icon={<SvgMonyIcon />}
        title={t.price}
        content={
          <ProductPrice
            priceWithoutDiscount={priceWithoutDiscount}
            price={price}
            sameLine={!(special_prices || []).length}
          />
        }
      />

      <EventDetailItem
        icon={<SvgCheckCircleIcon />}
        title={t.available_seats}
        content={available_seats.toString()}
      />

      {end_registration_date && (
        <EventDetailItem
          icon={<SvgCalenderIcon />}
          title={t.registration_end}
          content={`${end_registration_date ?? "_"}, ${
            end_registration_time ?? "_"
          }`}
        />
      )}

      <EventDetailItem
        icon={<SvgLocationIcon />}
        title={t.location}
        content={locationText}
      />
      {location && (
        <EventDetailItem
          content={<MapLink {...location}>{t.open_google_map}</MapLink>}
        />
      )}
    </div>
  );
};

export default EventDetails;
